/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Loading_DescInputs */

const es_toast_loading_desc = /** @type {(inputs: Toast_Loading_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor espera…`)
};

const en_toast_loading_desc = /** @type {(inputs: Toast_Loading_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait…`)
};

/**
* | output |
* | --- |
* | "Please wait…" |
*
* @param {Toast_Loading_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_loading_desc = /** @type {((inputs?: Toast_Loading_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Loading_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_loading_desc(inputs)
	return en_toast_loading_desc(inputs)
});
export { toast_loading_desc as "toast.loading_desc" }